import { NgModule, ModuleWithProviders } from '@angular/core';

import { UserServiceConfig, USER_CONFIG } from './user.config';
import {
  SessionService,
  UserService,
  ProfileService,
  RecoveryService,
} from './user.service';

@NgModule({
  providers: [
    SessionService,
    UserService,
    ProfileService,
    RecoveryService,
  ],
})
export class UserModule {

  static forRoot(config: UserServiceConfig): ModuleWithProviders<UserModule> {
    return {
      ngModule: UserModule,
      providers: [
        SessionService,
        UserService,
        ProfileService,
        RecoveryService,
        {
          provide: USER_CONFIG,
          useValue: config,
        },
      ],
    };
  }

  static forChild(config: UserServiceConfig): ModuleWithProviders<UserModule> {
    return UserModule.forRoot(config);
  }

}
